var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('header',{staticClass:"header_wrap"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"router-link-active",attrs:{"to":"/"}})],1)])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }